export default __webpack_public_path__ + "static/logoife_small_1x-4a008a8f015b92eaa47bbcacaf7225ca.png";